import { ISubscriptionStatusProps } from '../../types';
import SubscriptionStatusBadge from '../SubscriptionStatusBadge';
import ProductLabel from './labels/ProductLabel';

/**
 * Note: subscriptions with cancelled status are not sent to frontend from api currently
 * but this may change in future. Until that we show only product status and title
 */
export default function CancelledStatus({ subscription }: Readonly<ISubscriptionStatusProps>) {
  const { productId, secondProductId, status } = subscription;
  return (
    <>
      <SubscriptionStatusBadge status={status} />
      <ProductLabel productId={productId} family={!!secondProductId} />
    </>
  );
}
